import './JavaScript/Project/globals';

import 'vanilla-lazyload';
import 'jquery';

/**
 * Bootstrap
 */
import 'bootstrap/js/src/util';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
//import 'bootstrap/js/src/dropdown';
//import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/toast';
//import 'bootstrap/js/src/popover';

// Tiny-Editor
import 'tiny-editor';

import 'sweetalert2';

// Cropper.js
import 'cropperjs';
import 'browser-image-compression';

/**
 * Project plugins
 */
import './JavaScript/Plugins/Retyping';
import './JavaScript/Plugins/SweetAlert';
import './JavaScript/Plugins/ReadNotification';
import './JavaScript/Plugins/TextareaResize';
import './JavaScript/Plugins/InputMaxLengthIndicator';

/**
 * Project
 */
import './JavaScript/OneUI/main/app';
import './JavaScript/Project/PageLoadedQueue';
import './JavaScript/Project/Viewport';
import './JavaScript/Project/sizeChange';
import './JavaScript/Project/lazyload';
import './JavaScript/Project/Register';
import './JavaScript/Project/Tooltip';
import './JavaScript/Project/SearchInput';
import './JavaScript/Project/Shave';
import './JavaScript/Project/select';
import './JavaScript/Plugins/AddToCart';
import './JavaScript/Project/Navigation';

// Ads
import '../../../../Solutions.Neos.Ads/Resources/Private/Fusion/Component/Molecule/AdPartnerSlider/AdPartnerSlider';

// Experts
import '../../../../Solutions.Experts.Users/Resources/Private/Fusion/Form/NotificationForm/NotificationForm';
import '../../../../Solutions.Experts.Users/Resources/Private/Fusion/Form/SocialMediaForm/SocialMediaForm';

// Experts-Profile
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Component/Organism/ProfileBody/ProfilePage';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Form/UploadProfilePicture/UploadProfilePicture';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Form/UploadHeaderImage/UploadHeaderImage';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Form/KeywordForm/KeywordForm';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Form/InformationForm/InformationForm';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Form/DetailsForm/DetailsForm';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Form/QuestionsForm/QuestionsForm';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Form/VideoForm/VideoForm';
import '../../../../Solutions.Experts.Profile/Resources/Private/Fusion/Component/Atom/ProfileSlider/ProfileSlider';

// Messages
import '../../../../Solutions.Chat.Messages/Resources/Private/Fusion/Component/Organism/ChatView/ChatView';

// Bookmarks
import '../../../../Solutions.Bookmarks/Resources/Private/Assets/JavaScripts/Bookmark';

// Rating
import '../../../../Solutions.Rating/Resources/Private/Fusion/Component/Atom/RatingSelect/RatingSelect';

// Search
import '../../../../Solutions.Search/Resources/Private/Fusion/Component/Atom/SearchResults/SearchResults';
import '../../../../Solutions.Search/Resources/Private/Fusion/Component/Molecule/SearchModal/SearchModal';

// Announcements
import '../../../../Solutions.Tools.Announcements/Resources/Private/Assets/JavaScript/Announcements';
